import { Outlet } from 'react-router-dom';

export default function BankAccounts() {
    return (
        <Outlet />
    )
}
